export const getOnlineText = state => state.serverMenuReducer.status.online
export const getOfflineText = state => state.serverMenuReducer.status.offline
export const getVipText = state => state.serverMenuReducer.status.vip
export const getUnknownText = state => state.serverMenuReducer.status.unknown
export const getStatusTexts = state => state.serverMenuReducer.status



// WEBPACK FOOTER //
// ./src/features/ServerMenu/data/statusTexts/selectors.js